"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = SplitPanelItem;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _breakpoints = require("@site/pattern-library-utils/breakpoints");
var _density = require("@site/pattern-library-utils/density");
var _react2 = require("@linaria/react");
const Container = /*#__PURE__*/(0, _react2.styled)("div")({
  name: "Container",
  class: "pc-c1ox3g2w",
  vars: {
    "c1ox3g2w-0": [({
      allowWrap
    }) => allowWrap ? 'column nowrap' : 'row nowrap']
  }
});
const StartAlignedPanel = /*#__PURE__*/(0, _react2.styled)("div")({
  name: "StartAlignedPanel",
  class: "pc-s7c52qi",
  vars: {
    "s7c52qi-0": [({
      hasVideo
    }) => hasVideo ? 'column' : 'row']
  }
});
const EndAlignedPanel = /*#__PURE__*/(0, _react2.styled)("div")({
  name: "EndAlignedPanel",
  class: "pc-ein2f53",
  vars: {
    "ein2f53-0": [({
      allowWrap
    }) => allowWrap ? 'flex-start' : 'flex-end']
  }
});
function SplitPanelItem({
  startAlignedContent,
  endAlignedContent,
  allowWrap = false,
  hasVideo = false,
  endAlignedClassName = ''
}) {
  return /*#__PURE__*/_react.default.createElement(Container, {
    className: "split-panel-item",
    allowWrap: allowWrap,
    "data-cy": "split-panel-item"
  }, /*#__PURE__*/_react.default.createElement(StartAlignedPanel, {
    hasVideo: hasVideo,
    className: "start-aligned-panel"
  }, startAlignedContent), endAlignedContent && /*#__PURE__*/_react.default.createElement(EndAlignedPanel, {
    allowWrap: allowWrap,
    className: `end-aligned-panel ${endAlignedClassName}`
  }, endAlignedContent));
}
SplitPanelItem.propTypes = {
  startAlignedContent: _propTypes.default.object.isRequired,
  endAlignedContent: _propTypes.default.object,
  allowWrap: _propTypes.default.bool,
  hasVideo: _propTypes.default.bool,
  endAlignedClassName: _propTypes.default.string
};